import Vue from "vue";

import FPhone from "./FPhone";
import PhoneDisplay from "./PhoneDisplay";

Vue.component("FPhone", FPhone);
Vue.component("PhoneDisplay", PhoneDisplay);
